import { render, staticRenderFns } from "./Editbankaccount.vue?vue&type=template&id=308355cf&"
import script from "./Editbankaccount.vue?vue&type=script&lang=js&"
export * from "./Editbankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports